<template>
  <section>
    <TooltipView type="is-dark" :label="$t('Share in email')">
      <i class="icon cls cls-email-unread is-medium is-clickable" @click="onShare"></i>
    </TooltipView>
  </section>
</template>

<script>
import Lang from '/@/modules/core/app/services/Lang';
import { ReferralShareClickedEventTracking } from '/@/modules/platformreferral/segmentevents/ReferralShareClickedEventTracking';
import { PlatformReferralSegmentEventProperties } from '/@/modules/platformreferral/constants/PlatformReferralSegmentEventProperties';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DesktopMailReferral',
  components: { TooltipView },
  props: {
    referralLink: {
      type: String,
      required: true
    }
  },
  methods: {
    onShare() {
      ReferralShareClickedEventTracking.dispatch(
        PlatformReferralSegmentEventProperties.device.DESKTOP,
        PlatformReferralSegmentEventProperties.medium.EMAIL
      );
      const subject = Lang.t('platformreferral.email.subject');
      const body = Lang.t('platformreferral.email.body', {
        referralLink: this.referralLink
      });

      window.open(`mailto:?subject=${subject}&body=${body}`);
    }
  }
};
</script>
